import React from 'react';
import styled, { css } from 'styled-components';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
import { colors, colorUtils, layout } from '@prisjakt/ui-base';
import Clickable from '@prisjakt/ui-clickable';

export const ExpandableGroup = styled.div``;

type HeaderProps = {
  expanded: boolean;
  dark?: boolean;
};

export const Header = styled(Clickable)<HeaderProps>`
  align-items: center;
  color: ${props => props.theme.text.callToAction};
  cursor: pointer;
  display: flex;
  flex-direction: row;
  padding: ${layout.spacing.xSmall};
  text-align: left;
  transition: background-color ${layout.animations.buttonTransition};
  width: 100%;

  ${props =>
    props.expanded &&
    css`
      box-shadow: inset 0 -2px 0 ${props.theme.lines.groupHeader};
    `};

  ${props =>
    props.dark &&
    css`
      background-color: ${colors.backgroundDarkGray};
    `};

  &.focus-visible {
    background-color: ${colorUtils.setRgbaAlpha(colors.lightBlue1, '0.5')};
  }
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: ${layout.measurements.fontSizeNormal};
  padding: 0 ${layout.spacing.xSmall};
`;

type HeaderArrowProps = {
  expanded: boolean;
};

export const HeaderArrow = styled(({ expanded, ...props }) => (
  <ChevronDownIcon {...props} />
)).attrs({ size: 24 })<HeaderArrowProps>`
  transition: transform 0.15s ease-in-out;
  transform: ${props => (props.expanded ? 'scaleY(-1)' : 'none')};
`;

export const BadgeArea = styled.div`
  /* Align the badge to the right */
  margin-left: auto;
`;
